var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as ProductLineFactory from '../../../classes/definitions/brand/productLine';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import productLineSchema from '../../../schemas/productLineSchema';
import Input from '../../UI/Input/Input';
var ProductLineForm = /** @class */ (function (_super) {
    __extends(ProductLineForm, _super);
    function ProductLineForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.staticPageId = '';
        _this.brandId = '';
        _this.state = {
            formConfig: _.cloneDeep(productLineSchema),
            formIsValid: false,
            discardPopupVisble: false,
            productsSuggestions: [],
        };
        _this.isOnlyStaticPage = function () {
            return _this.staticPageId !== '-1' && _this.brandId === '-1';
        };
        _this.getStaticProductLine = function () {
            return _this.api.getStaticProductLine(_this.staticPageId, _this.editId);
        };
        _this.getProductLine = function () {
            var action = _this.isOnlyStaticPage() ? _this.getStaticProductLine() : _this.api.getProductLine(_this.editId);
            action
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на продуктова линия';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var productLine = ProductLineFactory.createProductLine(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'bg_name.value', productLine.BgName);
            _.set(updatedFormConfig, 'bg_name.touched', true);
            _.set(updatedFormConfig, 'bg_name.valid', true);
            _.set(updatedFormConfig, 'en_name.value', productLine.EnName);
            _.set(updatedFormConfig, 'en_name.touched', true);
            _.set(updatedFormConfig, 'en_name.valid', true);
            _.set(updatedFormConfig, 'position.value', productLine.Position);
            _.set(updatedFormConfig, 'position.touched', true);
            _.set(updatedFormConfig, 'position.valid', true);
            _.set(updatedFormConfig, 'products.value', productLine.ProductsFormatted);
            _.set(updatedFormConfig, 'products.touched', true);
            _.set(updatedFormConfig, 'products.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (elType === 'autocomplete') {
                if (event.value) {
                    updatedFormElement.value = event.value;
                }
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.getCreateUpdateAction = function (data) {
            var isEdit = _this.editId !== '-1';
            if (_this.isOnlyStaticPage()) {
                // create
                if (!isEdit) {
                    return _this.api.createStaticProductLine({ product_line: data }, _this.staticPageId);
                }
                // update
                return _this.api.updateStaticProductLine({ product_line: data }, _this.staticPageId, _this.editId);
            }
            // normal behaviour
            // create
            if (!isEdit) {
                return _this.api.createProductLine({ brand_product_line: data }, _this.brandId, _this.staticPageId);
            }
            // update
            return _this.api.updateProductLine({ brand_product_line: data }, _this.editId);
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedProductLine = ProductLineFactory.createProductLine({
                bg_name: _.get(formData, 'bg_name.value', ''),
                en_name: _.get(formData, 'en_name.value', ''),
                position: _.get(formData, 'position.value', 0),
                products: _.get(formData, 'products.value', []),
            });
            _this.getCreateUpdateAction(submittedProductLine)
                .then(function (response) {
                _this.toProductLinesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на линия от продукти';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toProductLinesPage = function () {
            if (_this.isOnlyStaticPage()) {
                _this.props.history.push(AppRoutes.staticPage.path + '/' + _this.staticPageId + AppRoutes.productLines.path);
            }
            else {
                _this.props.history.push(AppRoutes.brand.path +
                    '/' +
                    _this.brandId +
                    AppRoutes.staticPage.path +
                    '/' +
                    _this.staticPageId +
                    AppRoutes.productLines.path);
            }
        };
        _this.suggestOptions = function (event, type) {
            var searchString = event.query.toLowerCase();
            _this.api
                .searchProducts(searchString)
                .then(function (response) {
                var data = _.get(response, 'data.data', []);
                var results = [];
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var item = data_1[_i];
                    results.push({
                        label: _.get(item, 'attributes.name', ''),
                        value: _.get(item, 'id'),
                    });
                }
                var obj = {};
                obj['productsSuggestions'] = results;
                _this.setState(obj);
            })
                .catch(function (error) {
                var defaultMessage = 'Не можахме да намерим опции';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        return _this;
    }
    ProductLineForm.prototype.componentDidMount = function () {
        this.brandId = _.get(this.props, 'match.params.brandId', '-1');
        this.staticPageId = _.get(this.props, 'match.params.staticPageId', '-1');
        this.editId = _.get(this.props, 'match.params.productLineId', '-1');
        if (this.editId !== '-1') {
            this.getProductLine();
        }
    };
    ProductLineForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, productsSuggestions = _a.productsSuggestions;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, multiple: true, changed: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                }, blur: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                }, suggestions: productsSuggestions, completeMethod: function (event) { return _this.suggestOptions(event, formElement.id); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toProductLinesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return ProductLineForm;
}(React.Component));
// @ts-ignore
export default withRouter(ProductLineForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/ProductLines/ProductLineForm/ProductLineForm.tsx
// module id = 521
// module chunks = 0